import { ConcreteEncodable } from "./ConcreteEncodable";

import { TradingGroupImplEncoder } from "../../encoder/TradingGroupImplEncoder";

import * as CubiqTS from "../../index";
import { TradingGroup } from "../TradingGroup";

export class TradingGroupImpl extends ConcreteEncodable implements TradingGroup {
  public static enType: string = "com.bcdfx.model.TradingGroupImpl";

  /*FID=1*/
  public branchCode: string;
  /*FID=2*/
  public groupId: CubiqTS.Long | null = null;
  /*FID=3*/
  public groupCode: string;
  /*FID=4*/
  public typeId: CubiqTS.Long | null = null;
  /*FID=5*/
  public typeDisplayName: string;
  /*FID=6*/
  public isAutoFilledFg: boolean;
  /*FID=7*/
  public isExternallyFilledFg: boolean;
  /*FID=8*/
  public isInternallyArbitratedFg: boolean;
  /*FID=9*/
  public isBenchmarkFg: boolean;
  /*FID=10*/
  public isStagingFg: boolean;
  /*FID=11*/
  public pauseResumeFg: boolean;
  /*FID=12*/
  public acceptsPausedOrdersFg: boolean;
  /*FID=13*/
  public roundToMillionsType: CubiqTS.RoundToMillionsType;
  /*FID=14*/
  public isSupportsBMAlgosFg: boolean;
  /*FID=15*/
  public isProcessesFillUpdatesAfterCancellationEnabled: boolean;
  /*FID=16*/
  public gtcAsDayOrderConfGroup: boolean;
  /*FID=17*/
  public orderCancelReplaceFg: boolean;
  /*FID=18*/
  public fillNowFg: boolean;
  /*FID=19*/
  public supportsInvertsFg: boolean;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = TradingGroupImplEncoder.Instance;
    this.setEncodableType(TradingGroupImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "TradingGroupImpl[" +
      "branchCode=" +
      this.branchCode +
      "groupId=" +
      this.groupId +
      "groupCode=" +
      this.groupCode +
      "typeId=" +
      this.typeId +
      "typeDisplayName=" +
      this.typeDisplayName +
      "isAutoFilledFg=" +
      this.isAutoFilledFg +
      "isExternallyFilledFg=" +
      this.isExternallyFilledFg +
      "isInternallyArbitratedFg=" +
      this.isInternallyArbitratedFg +
      "isBenchmarkFg=" +
      this.isBenchmarkFg +
      "isStagingFg=" +
      this.isStagingFg +
      "pauseResumeFg=" +
      this.pauseResumeFg +
      "acceptsPausedOrdersFg=" +
      this.acceptsPausedOrdersFg +
      "roundToMillionsType=" +
      this.roundToMillionsType +
      "isSupportsBMAlgosFg=" +
      this.isSupportsBMAlgosFg +
      "isProcessesFillUpdatesAfterCancellationEnabled=" +
      this.isProcessesFillUpdatesAfterCancellationEnabled +
      "gtcAsDayOrderConfGroup=" +
      this.gtcAsDayOrderConfGroup +
      "orderCancelReplaceFg=" +
      this.orderCancelReplaceFg +
      "fillNowFg=" +
      this.fillNowFg +
      "supportsInvertsFg=" +
      this.supportsInvertsFg +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
